jQuery.fn.extend({
    insertAtCaret: function(value){
        return this.each(function(i) {
            if (document.selection) { //Internet Explorer
                this.focus();
                sel = document.selection.createRange();
                sel.text = value;
                this.focus();
            }
            else if (this.selectionStart || this.selectionStart == '0') { //browsers
                var startPos = this.selectionStart;
                var endPos = this.selectionEnd;
                var scrollTop = this.scrollTop;
                this.value = this.value.substring(0, startPos)+value+this.value.substring(endPos,this.value.length);
                this.focus();
                this.selectionStart = startPos + value.length;
                this.selectionEnd = startPos + value.length;
                this.scrollTop = scrollTop;
            } else {
                this.value += value;
                this.focus();
            }
        })
    }
});

ready().then(function() {
    $('.emoji-list li').on('click',function () {
        $("#review").insertAtCaret($(this).find('span').html());
    });
});
